import axiosService from '../axios'

export const list = (params?: any) => {
  return axiosService({
    url: '/api.sell-request-source',
    method: 'get',
    params,
  })
}

export const get = (id: number) => {
  return axiosService({
    url: `/api.sell-request-source/${id}`,
    method: 'get',
  })
}

export const update = (id: number, data: any) => {
  return axiosService({
    url: `/api.sell-request-source/${id}`,
    method: 'put',
    data,
  })
}

export const create = (data: any) => {
  return axiosService({
    url: '/api.sell-request-source',
    method: 'post',
    data,
  })
}
